import { Button, Box } from "@mui/material";
import { useNavigate } from "react-router";

export const RecommendRecipeButton = () => {
	const navigate = useNavigate();
	return (
		<Box sx={{ textAlign: "center" }}>
			<Button
				onClick={() => navigate("/recommendRecipe")}
				sx={{ width: "90%", paddingY: 4, marginY: 2 }}
				variant="contained"
			>
				Not sure what to have? Get a recommendation
			</Button>
		</Box>
	);
};
